const GUEST_IDENTITY_LOCAL_KEYS = [
  "nogosh.guestOwner.session",
  "nogosh.guestUpgrade.token",
  "nogosh.guestUpgrade.completed",
  "nogosh.guestUpgrade.decisions",
  "nogosh.guestContinuation.observers",
  "nogosh.publicInvite.participantClaims"
];

const GUEST_IDENTITY_LOCAL_PREFIXES = [
  "publicInviteParticipant:"
];

export const clearGuestIdentityBrowserState = (): void => {
  GUEST_IDENTITY_LOCAL_KEYS.forEach((key) => localStorage.removeItem(key));
  Object.keys(localStorage)
    .filter((key) => GUEST_IDENTITY_LOCAL_PREFIXES.some((prefix) => key.indexOf(prefix) === 0))
    .forEach((key) => localStorage.removeItem(key));
};
